import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		info: {
			marginLeft: 10
		},
		dynamicContentContainer: {
			width: "95%"
		}
	} satisfies Record<string, CSSObject>;
};